import { render, staticRenderFns } from "./VenueGoverningLawInput.vue?vue&type=template&id=64c41f41&"
import script from "./VenueGoverningLawInput.vue?vue&type=script&lang=js&"
export * from "./VenueGoverningLawInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/apps/eneforhandler/components/form/VenueGoverningLawInput.vue
// module id = null
// module chunks = 